import { render } from "./MovieView.vue?vue&type=template&id=fb4d0b0e"
import script from "./MovieView.vue?vue&type=script&lang=js"
export * from "./MovieView.vue?vue&type=script&lang=js"

import "./MovieView.vue?vue&type=style&index=0&id=fb4d0b0e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__